// Event Bus
import EventBus from "@/app/bus/event-bus.js"

// Components
const ModalCancelOrder = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-cancel-order"*/ "@/app/views/main-view/dog-purchase/containers/dog-transaction-history-container/modals/modal-cancel-order/modal-cancel-order.vue"
	)
const ProductItemCard = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "product-item-card" */ "@/app/views/main-view/_shared/_components/product-item-card/product-item-card.vue"
	)

// Services
import TransactionService from "@/app/services/main/transaction/transaction-service"
import ProductService from "@/app/services/main/product/product-service.js"
import paymentService from "@/app/services/main/payment/payment-service.js"

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { mobileNumberMixins } from "@/app/mixins/utils/mobile-number-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins"

// Constants
import { STATUS_CODES, DOG_ORDER_STATUS, PRODUCT_ORDER_STATUS, CANCELLATION_TYPE } from "@/app/constants/status-constants"
import { SUBSCRIPTION_STATUS } from "@/app/constants/subscription-constants";

export default {
	name: "ProductPurchaseDetailsContainer",
	mixins: [toastMessageMixins, dateMixins, mobileNumberMixins, userMixins],
	components: {
		ModalCancelOrder,
		ProductItemCard,
	},
	data() {
		return {
			orderId: null,
			pageType: null,
			isAPILoading: false,
			orderDetails: {
				subscription: [],
			},
			orderHistory: [],
			breedDetails: {},
			petDetails: {},
			paymentMethods: "",
			hideCancellationModalStatuses: [
				"Out for delivery",
				"For cancellation",
				"Cancelled",
				"Delivered",
				"Refunded",
				"Picked up",
				"FAILED",
			],
			theads: [
				{ name: "Image", sortLabel: null, isDesc: false, style: null },
				{ name: "Products", sortLabel: null, isDesc: false, style: null },
				{ name: "Quantity", sortLabel: null, isDesc: false, style: null },
				{ name: "Price", sortLabel: null, isDesc: false, style: "width: 100px;" },
			],
			theadsPayment: [
				{ name: "Payment Method", sortLabel: null, isDesc: false, style: null },
				{ name: "Status", sortLabel: null, isDesc: false, style: null },
				{ name: "Message", sortLabel: null, isDesc: false, style: null },
				{ name: "Price", sortLabel: null, isDesc: false, style: null },
			],

			subtotal: 0,
			
			subscriptionStatus: "",

			cancellationTitle: "Request for Refund",
			cancellationText: "Are you sure you want to refund this order? Please state your reason in the textbox below.",
			cancellationType: CANCELLATION_TYPE.PRODUCT_REFUND,
		}
	},
	computed: {
		isNativeApp() {
			return this.$store.getters.getIsNativeApp
		},
		getActivePetName() {
			return this.$store.getters.getActivePet.name
		},
		displayViewSubscription(){
			const { isSubscription } = this.orderDetails;
			return isSubscription;
		}
		// showCancelSubscriptionOption() {
		// 	const isSubscription = this.orderDetails.subscription.length > 0;
        //     return isSubscription && (this.subscriptionStatus !== SUBSCRIPTION_STATUS["C"] && this.subscriptionStatus !== SUBSCRIPTION_STATUS["For cancellation"]);
        // },
	},
	created() {
		this.checkRoute()
	},
	watch: {
		$route: {
			handler() {
				this.checkRoute()
			},
			deep: true,
		},
	},
	methods: {
		checkRoute() {
			this.paymentMethods = ""
			this.orderId = this.$route.params.orderId
			this.pageType = "transactions"
			this.getOrderDetails()
		},
		getOrderDetails() {
			this.isAPILoading = true
			TransactionService.getTransactionOrderById(this.orderId)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const bundles = res.data.bundles.map((bundle) => {
							if (!bundle.isCustomBundle) {
								return {
									...bundle,
									products: bundle.products.map((product) => {
										return {
											...product,
											quantity: parseInt(bundle.quantity),
										}
									}),
								}
							} else {
								return bundle
							}
						})
						this.orderDetails = { ...res.data, bundles };
						const currentPayments = this.orderDetails.payment;

						// sort payment history via status alphabetically
						const currentPaymentsSorted = [...currentPayments].sort((a, b) => {
							let sa = a.status.toLowerCase(),
							sb = b.status.toLowerCase();

							if (sa > sb) {
								return -1;
							}
							if (sa < sb) {
								return 1;
							}
							return 0;
						});

						const ids = currentPaymentsSorted.map(({ name }) => name);
						const payments = currentPaymentsSorted.filter(({ name }, index) => !ids.includes(name, index + 1));
						
						this.orderDetails = {...this.orderDetails, payment: payments};

						this.subtotal = parseFloat(this.orderDetails.totalPrice) - (parseFloat(this.orderDetails.deliveryFee) || 0);
						
						if (this.pageType === "dog-transactions") {
							this.getPetDetails(res.data.bundles[0])
						}
						this.formatOrderHistory([
							...res.data.transactionPetOrderHistory,
							...res.data.transactionHistory,
						])
						this.getOrderPaymentMethod(res.data.paymentMethod)

						const { subscription } = this.orderDetails;
						this.subscriptionStatus = subscription && subscription.length > 0 ? SUBSCRIPTION_STATUS[subscription[0].status] : null;
					} else if (res.status === STATUS_CODES.NOT_FOUND) { 
						EventBus.$emit('errorUnAuthorizeUser', true);
					} else {
						this.showAPIErrorToast("Unable to get transaction details.", res)
						
					}
					this.isAPILoading = false
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAPILoading = false
				})
		},
		getOrderPaymentMethod(value) {
			this.paymentMethods = ""
			for (const i in value) {
				this.paymentMethods += `${value[i].name} ($ ${value[i].amount})`
				if (i < value.length - 1) {
					this.paymentMethods += " <br/>"
				}
			}
		},
		formatOrderHistory(orderHistory) {
			let orderHistoryTemp = []
			if (orderHistory) {
				for (const data of orderHistory) {
					const { date, status, remarks, submittedBy } = data;

					let content =
						(this.pageType === "transactions"
							? PRODUCT_ORDER_STATUS[data.status]
							: DOG_ORDER_STATUS[data.status]) || data.status

					if (data.status === "For cancellation") {
						content += `<p class="color-warning mt-2 mb-1">Reason: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`;
					} else if (data.status === "Disapproved cancellation") {
						content += `<br> <p class="color-warning color-warning mt-2 mb-1">Remarks: ${remarks}</p>`;
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`;
					}
					if (data.status === "For delivery" && !!remarks) {
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					}

					orderHistoryTemp.push({
						htmlMode: true,
						content: `[${this.utcConvertToZonedTime(data.date, "dd-MMM-yyyy hh:mm a", true)}] : ${content}`,
					})
				}
			}
			this.orderHistory = orderHistoryTemp.reverse()
		},
		getPetDetails(bundles) {
			this.isAPILoading = true
			let petId = null
			for (const product of bundles.products) {
				if (product.productTypeId === 6) {
					petId = product.id
				}
			}

			ProductService.getProductsDogDetails(petId)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.petDetails = res.data
						this.breedDetails = this.getBreedDetails(res.data.breedId)
					} else {
						this.showAPIErrorToast("Unable to get pet details.", res)
					}
					this.isAPILoading = false
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAPILoading = false
				})
		},
		getBreedDetails(id) {
			const breedList = this.$store.getters.getBreedLists
			const breedDetails = breedList.filter((breed) => {
				return breed.id === id
			})
			return breedDetails[0]
		},
		getProductPrice(type) {
			if (this.orderDetails.bundles) {
				const products = this.orderDetails.bundles[0].products
				for (const product of products) {
					if (type === product.productTypeId) {
						return product.priceAtOrder
					}
				}
			}
		},
		returnToPreviousPage() {
			const pageType = this.$route.params.type

			if (this.isNativeApp) {
				this.$router.push(pageType === "transactions" ? "/purchases" : "/purchases/dog-transactions")
			} else {
				this.$router.go(-1)
			}
		},
		showCancelOrderModal(cancellationType) {

			// Product Refund
			if(cancellationType === CANCELLATION_TYPE.PRODUCT_REFUND){
				this.$refs.modalCancelOrder.openModal(this.orderDetails);

				this.cancellationTitle = "Request for Refund";
				this.cancellationText = "Are you sure you want to refund this order? Please state your reason in the textbox below.";
				this.cancellationType = CANCELLATION_TYPE.PRODUCT_REFUND;
			}
			else{
				// Cancel Subscription
				const petId = this.getActivePet.id

				const { id: orderId, subscription } = this.orderDetails;

				const subscriptionDetails = {
					id: subscription[0].id,
					orderDetails: { id: orderId },
					petId,
				}

				this.cancellationTitle = "Cancel Subscription";
				this.cancellationText = "Are you sure you want to cancel this subscription? Please state your reason in the textbox below.";
				this.cancellationType = CANCELLATION_TYPE.SUBSCRIPTION_CANCELLATION;

				this.$refs.modalCancelOrder.openModal(subscriptionDetails || []);
			}
		},
		orderedCancelled() {
			this.getOrderDetails()
			this.closeCancelOrderModal()
		},
		closeCancelOrderModal() {
			$(this.$refs.modalCancelOrder).off("hide.bs.modal", this.handleHideEvent)
		},
		hideCancellationButton() {
			return !this.hideCancellationModalStatuses.includes(this.orderDetails.status)
		},
		showEmail(email) {
			if (email) {
				window.location.href = `mailto:${email}`
			}
		},
		proceedToPayment(orderId) {
			try {
				paymentService.getLatitudeInterestFreeUrl(orderId).then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.redirectToLpInterestFree(res.data.redirectUrl)
					} else {
						this.showAPIErrorToast("", res)
					}
				})
			} catch (error) {
				this.showGenericErrorToast()
			}
		},

		redirectToLpInterestFree(url) {
			const latitudeInterestFreeImg = require("@/assets/images/_shared/latitude-interest-free-logo.svg")
			this.$swal({
				title: "Redirecting to ...",
				html: `<img style='width: 300px' src=${latitudeInterestFreeImg}>`,
				allowOutsideClick: false,
				timer: 2000,
				showCancelButton: false,
				showConfirmButton: false,
			}).then(() => {
				window.location = url
			})
		},
		confirmCancelOrder(orderId) {
			this.$swal({
				imageHeight: "30px",
				imageAlt: "Confirm Dog",
				title: "CANCEL ORDER",
				text: `Are you sure you want to cancel this order?`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					this.updateOrderStatus(orderId)
				}
			})
		},
		async updateOrderStatus(orderId) {
			try {
				const statusBody = { status: "Cancelled" }
				const response = await TransactionService.updateProductOrderStatus(orderId, statusBody)

				if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					// Show success toast
					this.showCustomSuccessToast(null, `Your order has been cancelled!`)
					// refetch order details
					this.getOrderDetails()
				}
			} catch (error) {
				this.showGenericErrorToast()
			}
		},
		goToSubscription(){
			const { subscription, isSubscription } = this.orderDetails;

			if(!isSubscription){
				return;
			}

			const { id: subscriptionId } = subscription[0];
			this.$router.push(`/purchases/subscriptions/${subscriptionId}/view?fromAction=product-details`)
		}
	},
}
